<template>
    <section class="main-slides">
        <swiper class="swiper" :options="options">
            <swiper-slide v-for="(item, index) in items" :key="index">
                <v-card tile flat class="slide-item" :class="`slide-item--${item.code}`">
                    <img :src="`/images/main/slides/${item.code}.jpg`" :alt="item.text" class="slide-item__image" />
                    <router-link :to="`/shop?category=${item.code}`" class="slide-item__link">
                        <span class="d-sr-only">자세히보기</span>
                    </router-link>
                </v-card>
            </swiper-slide>
        </swiper>
    </section>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            options: {
                effect: "fade",
                allowTouchMove: true,
                centeredSlides: true,
                spaceBetween: 0,
                // autoplay: {
                //     delay: 5000,
                //     disableOnInteraction: false,
                // },
                speed: 500,
                loop: true,
            },
            items: [
                {
                    code: "VEAUTY-LAC",
                    text: "진정한 아름다움의 시작, 이너뷰티로부터. 뷰티락",
                },
                {
                    code: "LIFE-BALANCE",
                    text: "일상의 활력을 위한 라이프 밸런스",
                },
                {
                    code: "GROWTH-BALANCE",
                    text: "가족과 반려동물은 물론, 작물과 가축, 바다까지. 그로스 밸런스",
                },
                {
                    code: "LIFE-PLUS",
                    text: "삶의 가치를 더하는 라이프 플러스",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.main-slides {
    .swiper-slide {
        .slide-item {
            position: relative;
            &__image {
                display: block;
                width: 100%;
            }
            &__link {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
        }
    }
}
@media (min-width: 1024px) {
    .main-slides {
        .swiper-slide {
            .slide-item {
                &__link {
                    width: calc(160 / 1920 * 100%);
                    height: calc(48 / 980 * 100%);
                    left: calc(240 / 1920 * 100%);
                }
                &--VEAUTY-LAC {
                    .slide-item__link {
                        top: calc(563.5 / 980 * 100%);
                    }
                }
                &--LIFE-BALANCE {
                    .slide-item__link {
                        top: calc(541 / 980 * 100%);
                        left: calc(1400 / 1920 * 100%);
                    }
                }
                &--GROWTH-BALANCE {
                    .slide-item__link {
                        top: calc(573.5 / 980 * 100%);
                    }
                }
                &--LIFE-PLUS {
                    .slide-item__link {
                        top: calc(541 / 980 * 100%);
                        left: calc(1520 / 1920 * 100%);
                    }
                }
            }
        }
    }
}
</style>